// components/MetaTags.jsx
import { Helmet } from 'react-helmet-async';

const MetaTags = ({ 
    title = "Dr Easy - Your Trusted Medical Information Source", 
    description = "Read professional medical articles and health tips from trusted doctors", 
    image = "/public/logo.png", 
    url = window.location.href,
    type = "article",
    author = "",
    publishedTime = "",
    siteName = "Dr Easy",
    locale = "en_US"    
}) => {
    // تأكد إن الصورة صحيحة وكاملة
    const fullImageUrl =image
    return (
        <Helmet>
            {/* Basic Meta Tags */}
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="facebook-domain-verification" content="z9x9k1e8wveko201ns4taj2pdyxskc" />
            
            {/* Open Graph / Facebook - الأهم للفيسبوك */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={fullImageUrl} />
            <meta property="og:image:secure_url" content={fullImageUrl} />
            <meta property="og:image:type" content="image/png" />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:image:alt" content={title} />
            <meta property="og:site_name" content={siteName} />
            <meta property="og:locale" content={locale} />
            
            {/* Article specific tags */}
            {type === 'article' && publishedTime && (
                <meta property="article:published_time" content={publishedTime} />
            )}
            {type === 'article' && author && (
                <meta property="article:author" content={author} />
            )}
            
            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@dreasy" />
            <meta name="twitter:url" content={url} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content="/public/logo.png" />
            <meta name="twitter:image:alt" content={title} />
            
            {/* Additional Meta Tags للتحسين */}
            <meta name="robots" content="index, follow" />
            <meta name="author" content={author || siteName} />
            <link rel="canonical" href={url} />
        </Helmet>
    );
};

export default MetaTags;